import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../storage.service';

@Injectable({
    providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
    constructor(private _router: Router, private key: StorageService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | boolean | UrlTree {
        const isDevSession = localStorage.getItem('dev_session') === 'true';
        const userEnc = localStorage.getItem('user');
        const tokenEnc = localStorage.getItem('a_id');

        // Jika TIDAK ada token atau user data → belum login, izinkan ke sign-in
        if (!tokenEnc || !userEnc) {
            return true;
        }

        try {
            let user: any;
            if (isDevSession) {
                user = JSON.parse(userEnc);
            } else {
                user = JSON.parse(this.key.decryptionAES(userEnc));
            }

            if (user) {
                const isVerified =
                    typeof user.is_verified === 'boolean'
                        ? user.is_verified
                        : !!user.verified_at;

                if (!isVerified) {
                    return this._router.createUrlTree(['/pending-verification']);
                }

                return this._router.createUrlTree(['/dashboard']);
            }
            return true;
        } catch (e) {
            // Jika gagal decrypt, anggap belum login
            return true;
        }
    }
}
